<template>
  <PricesListCard
    :show-all-href="showAllHref"
    list-qa="lpu_services_service_list"
    more-qa="lpu_services_btn-more"
  >
    <PricesServiceRow
      v-for="(service, index) in services"
      :key="service.id ?? service.synonym_id"
      :service="service"
      :is-striped="index % 2 === 1"
      :is-calendar-open="openedSynonymId === service.synonym_id"
      :lpu-id="lpuId"
      :town-timedelta="townTimedelta"
      @open-calendar="openedSynonymId = $event.synonym_id"
      @close-calendar="openedSynonymId = null"
      @empty-schedule="emit('empty-schedule', $event)"
      @slot="onSlot"
    />
  </PricesListCard>
</template>

<script lang="ts" setup>
import { ref } from 'vue'
import PricesListCard from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuPrices/components/PricesListCard.vue'
import PricesServiceRow from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuPrices/components/PricesServiceRow.vue'
import type { SynonymPrice } from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuPrices/types'

defineProps<{
  services: SynonymPrice[]
  showAllHref?: string
  lpuId: number
  townTimedelta: number
}>()

type Emits = {
  (_event: 'empty-schedule', _service: SynonymPrice): void
  (_event: 'slot', _service: SynonymPrice, _date: string, _time: string): void
}

const emit = defineEmits<Emits>()
const openedSynonymId = ref<number | null>(null)

function onSlot(service: SynonymPrice, date: string, time: string) {
  emit('slot', service, date, time)
}
</script>
